module.exports = __webpack_public_path__ + "static/media/APP_OfficeChamp_152x174_3.e98beeb0.png";